import { Injectable } from '@angular/core';
import { PaginatedResponse } from '../../../interface/PaginatedResponse';
import { RestService } from '../../../services/rest.service';
import { CreatePlanPurchaseDto } from '../dto/create-plan-purchase.dto';
import { GetPlanPurchaseQueryDto } from '../dto/get-plan-purchase-query.dto';
import { PlanPurchaseStats } from '../interface/plan-purchase-stats.interface';
import { PlanPurchase } from '../models/plan-purchase.model';

@Injectable({
  providedIn: 'root',
})
export class PlanPurchaseMasterService {
  public readonly apiEndpoint = 'master/plan-purchase';

  constructor(private restService: RestService) {}

  create(createPlanPurchaseDto: CreatePlanPurchaseDto) {
    return this.restService.send({
      url: this.apiEndpoint,
      method: 'POST',
      body: createPlanPurchaseDto,
    });
  }

  async readAll(
    page: number = 1,
    query: Partial<GetPlanPurchaseQueryDto> = {},
  ): Promise<PaginatedResponse<PlanPurchase>> {
    return (
      await this.restService.send<PaginatedResponse<PlanPurchase>>({
        url: this.apiEndpoint,
        method: 'GET',
        query: {
          page,
          paginated: true,
          limit: query.limit,
          orgId: query.orgId || undefined,
          status: query.status || undefined,
          sortBy: query.sortBy || undefined,
          sortOrder: query.sortOrder ?? undefined,
        },
      })
    ).data;
  }

  async getStats(): Promise<PlanPurchaseStats> {
    return (
      await this.restService.send<PlanPurchaseStats>({
        url: this.apiEndpoint + '/stats',
        method: 'GET',
      })
    ).data;
  }

  async removePlan(planPurchaseId: string, remark: string): Promise<PlanPurchase> {
    return (
      await this.restService.send<PlanPurchase>({
        url: this.apiEndpoint + '/remove/' + planPurchaseId,
        method: 'PUT',
        body: { remark },
        throwError: true,
      })
    ).data;
  }

  async updateExpiry(planPurchaseId: string, expireTime: string): Promise<PlanPurchase> {
    return (
      await this.restService.send<PlanPurchase>({
        url: this.apiEndpoint + '/' + planPurchaseId + '/expiry',
        method: 'PUT',
        body: { expireTime },
        throwError: true,
      })
    ).data;
  }
}
